module.exports = __webpack_public_path__ + "static/media/ireneinhetatelier-min.f8c02507.png";